import {IMAGES} from './images';
import {LINKS, PATHS} from '@/const';
import {IMAGES_V2} from '@/modules/institutional-client/images';
import lang from './RewardsHubPage.lang';

// 任务ID，与后端对齐，用于在/task/list接口中查找元数据
export const TASK_ID_GATHER = {
  // KYC (identity / advance)
  KYC: 38,
  // 首次入金
  FIRST_DEPOSIT: 33,
  // 首次入金 + KYC
  FIRST_DEPOSIT_KYC: 36,
  // 首次交易
  FIRST_TRADE: 42,
  // 首次交易 + KYC
  FIRST_TRADE_KYC: 44,
};

export const GetTaskList = (is_JP_KR = false, isKolWhiteListChannel = false, isLogin = false, isKycInit) => {
  const initStatus = isLogin ? 'NOT_STARTED' : 'NOT_LOGIN';
  // 日韩 或者 特殊渠道用户
  const isSpecialUser = is_JP_KR || isKolWhiteListChannel;
  const depositId = isSpecialUser && isKycInit ? TASK_ID_GATHER.FIRST_DEPOSIT : TASK_ID_GATHER.FIRST_DEPOSIT_KYC;
  const tradeId = isSpecialUser && isKycInit ? TASK_ID_GATHER.FIRST_TRADE : TASK_ID_GATHER.FIRST_TRADE_KYC;
  return [
    is_JP_KR
      ? {
          icon: IMAGES.AWARDS_BOUNS_1,
          successIcon: IMAGES.AWARDS_BOUNS_SUCCESS_1,
          claimSuccessIcon: IMAGES.AWARDS_BOUNS_CLAIM_SUCCESS_1,
          title: lang.CompleteIdentifyVerification_JP_KO,
          titleDesc: lang.CompleteIdentifyVerification_DESC_JP_KO,
          button: lang.GoVerify,
          bonus: '10 ~ 1,200 USDT',
          bonusType: 1,
          min: 10,
          max: 1200,
          status: 'INIT',
          id: TASK_ID_GATHER.KYC,
          taskId: TASK_ID_GATHER.KYC,
          url: PATHS.ACCOUNT_VERIFICATION.pathname,
          stepStatus: initStatus,
        }
      : {
          icon: IMAGES.AWARDS_BOUNS_1,
          successIcon: IMAGES.AWARDS_BOUNS_SUCCESS_1,
          claimSuccessIcon: IMAGES.AWARDS_BOUNS_CLAIM_SUCCESS_1,
          title: lang.CompleteIdentifyVerification_OTHER,
          titleDesc: lang.CompleteIdentifyVerification_DESC_OTHER,
          button: lang.GoVerify,
          bonus: '10~1,200 USDT',
          bonusType: 1,
          min: 10,
          max: 1200,
          status: 'INIT',
          id: TASK_ID_GATHER.KYC,
          taskId: TASK_ID_GATHER.KYC,
          url: PATHS.ACCOUNT_VERIFICATION.pathname,
          stepStatus: initStatus,
        },
    {
      icon: IMAGES.AWARDS_BOUNS_1,
      successIcon: IMAGES.AWARDS_BOUNS_SUCCESS_1,
      claimSuccessIcon: IMAGES.AWARDS_BOUNS_CLAIM_SUCCESS_1,
      title: lang.FirstTimeDeposit,
      titleDesc: lang.CompleteYourFirstDepositNew,
      button: lang.GoDepositNew,
      bonus: '5 ~ 1,500 USDT',
      bonusType: 1,
      min: 5,
      max: 1500,
      status: 'INIT',
      id: depositId,
      taskId: depositId,
      url: PATHS.ASSETS_DEPOSIT.pathname,
      stepStatus: initStatus,
    },
    {
      icon: IMAGES.AWARDS_BOUNS_1,
      successIcon: IMAGES.AWARDS_BOUNS_SUCCESS_1,
      claimSuccessIcon: IMAGES.AWARDS_BOUNS_CLAIM_SUCCESS_1,
      title: lang.FirstTimeTrading,
      titleDesc: lang.CompleteYourFirstTradingNew,
      button: lang.GoTradeNew,
      bonusType: 2,
      bonus: '5~2,100 USDT',
      min: 5,
      max: 2100,
      status: 'INIT',
      id: tradeId,
      taskId: tradeId,
      url: LINKS.PHEMEX_SPOT_TRADE,
      stepStatus: initStatus,
    },
  ];
};

export function TASK_LIST(LG, isLogin, kolInfo) {
  const list = [
    {
      icon: IMAGES.NEW_BONUS_1,
      icon_bonus: IMAGES.NEW_BONUS_5,
      title: LG(isLogin ? lang.CompleteIdentifyVerification : lang.RegistrationAndCompletion),
      titleDesc: LG(isLogin ? lang.CompletionYouHaveAReward : lang.YouHaveAReward),
      bonus: LG(lang.bonus1),
      bonusDesc: LG(lang.RewardForWithdrawal),
      button: LG(lang.GoVerify),
      status: 'INIT',
      isShowBonus: true,
      id: 38,
      url: PATHS.ACCOUNT_VERIFICATION.pathname,
    },
    {
      icon: IMAGES.NEW_BONUS_2,
      icon_bonus: IMAGES.NEW_BONUS_5,
      title: LG(lang.FirstTimeDeposit),
      titleDesc: LG(isLogin ? lang.CompleteYourFirstDeposit : lang.CompleteYourFirst),
      bonus: LG(lang.bonus2),
      bonusDesc: LG(lang.RewardForWithdrawal),
      button: LG(lang.GoDeposit),
      status: 'INIT',
      isShowBonus: false,
      id: 36,
      url: PATHS.ASSETS_DEPOSIT.pathname,
    },
    {
      icon: IMAGES.NEW_BONUS_3,
      icon_bonus: IMAGES.NEW_BONUS_5,
      title: LG(lang.FirstTimeTrading),
      titleDesc: LG(isLogin ? lang.CompleteYourFirstTrading : lang.CompleteYourFirstTrade),
      bonus: LG(lang.bonus3),
      bonusDesc: LG(lang.RewardForWithdrawal),
      button: LG(lang.GoTrade),
      status: 'INIT',
      isShowBonus: false,
      id: 44,
      url: LINKS.PHEMEX_SPOT_TRADE,
    },
    {
      icon: IMAGES.NEW_BONUS_11,
      icon_bonus: IMAGES.NEW_BONUS_5,
      title: LG(lang.NewcomerAdvancedTrading),
      titleDesc: LG(isLogin ? lang.CompleteTheNewcomerTrading : lang.CompleteTheNewcomer),
      bonus: LG(lang.bonus4),
      bonusDesc: LG(lang.RewardForWithdrawal),
      button: LG(lang.GoTrade),
      status: 'INIT',
      isShowBonus: false,
      id: 50,
      url: LINKS.PHEMEX_CONTRACT_TRADE,
    },
    {
      icon: IMAGES.NEW_BONUS_4,
      icon_bonus: IMAGES.NEW_BONUS_6,
      title: LG(lang.PhemexVIP),
      titleDesc: LG(lang.ByCompletingThe),
      bonus: LG(lang.MintPhemexSoulPass),
      bonusDesc: LG(lang.MintPhemexSoulPassWithout),
      button: LG(lang.GoMint),
      status: 'INIT',
      isShowBonus: false,
      id: 70,
      url: PATHS.WEB3_SOUL_PASS.pathname,
    },
  ];
  if (kolInfo && kolInfo.name) {
    list.splice(1, 0, {
      type: TASK_TYPE.KOL_REFERRAL_ACTIVITY,
      isShowBonus: false,
      id: Date.now(),
    });
  }
  return list;
}

export function PROGRAM_LIST(LG, lang, fixLink) {
  return [
    {
      title: LG(lang.InviteYourFriends),
      content: LG(lang.SharePrize),
      hrefTitle: LG(lang.InviteNow),
      imgSrc: IMAGES_V2.BONUS_PROGRAM_1,
      href: fixLink(PATHS.ACCOUNT_INVITE_FRIENDS.pathname),
    },
    {
      title: LG(lang.PhemexCollaboratorProgram),
      content: LG(lang.AffliateCommissions),
      hrefTitle: LG(lang.ApplyNow),
      imgSrc: IMAGES_V2.BONUS_PROGRAM_2,
      href: fixLink(PATHS.ALL_STAR_PROGRAM.pathname),
    },
  ];
}

export const USER_KOL_REFERRAL_ACTIVITY_STATUS = {
  CLAIMED: 50,
  AT_RISK: 40,
  END: 70,
};

export const TASK_TYPE = {
  KOL_REFERRAL_ACTIVITY: 'kol-referral-activity',
};

export const KOL_REFERRAL_ACTIVITY_STAGE = {
  DEPOSIT_TRADE: 1,
  RISK_MONITORING: 2,
  BONUS_CLAIM: 3,
  BONUS_CLAIM_EXPIRED: 4,
  END: 5,
};

export const NEED_KYC_CODE = 50108;

export const ACTIVITY_ID_LIST = {
  38: '135',
  36: '134',
  33: '134',
  44: '137',
  42: '137',
  50: '136',
};

export const ELEM_CONTENT_LIST = {
  38: 'go_advanced_kyc',
  36: 'go_first_time_deposit',
  33: 'go_first_time_deposit',
  44: 'go_first_time_trading',
  42: 'go_first_time_trading',
  50: 'complete_advanced_trading',
  70: 'go_mint_psp',
};

export const BONUS_TYPE_TEXT = {
  SPOT: lang.SpotBonusType,
  CONTRACT: lang.ContractBonusType,
};

export const BONUS_TYPE_RESEVER = {
  SPOT: 'SPOT',
  CONTRACT: 'CONTRACT',
};
